import React from 'react';
import validate from 'validate.js';

const validateMessageOptions = (values) => {
  const {
    reminder_preference = []
  } = values || {};
  return {
    reminder_preference: reminder_preference.length > 0 ? undefined : validate.single(reminder_preference,
      {
        presence: { allowEmpty: false }
      })
  };
};
export default validateMessageOptions;
